import React, { Component } from 'react'
import lodash from 'lodash'
import { observer } from 'mobx-react'

import Header from './components/header'
import Menu from './components/menu'
import Footer from './components/footer'
import ForgotPassword from './components/forgotpassword'
import Login from './components/login'
import TopBar from './components/topbar'
import InvoiceView from './components/invoices/invoiceview'
import PasswordReset from './components/passwordreset'
import ProcessPayment from './components/invoices/processpayment'
import PaymentConfirmation from './components/invoices/paymentconfirmation'

@observer(['globals', 'users'])
export default class Main extends Component {
  
  render() {
    let userHash = localStorage.getItem('userHash')
    let route = this.props.location.pathname.split('/')

    if (route[1] == 'invoiceview') {
      return <InvoiceView token={ this.props.params.token }/>
    }
    else if (route[1] == 'processpayment') {
      return <ProcessPayment token={ this.props.params.token }/>
    }
    else if (route[1] == 'paymentconfirmation') {
      return <PaymentConfirmation />
    }
    else if (route[1] == 'forgotpassword') {
      return <ForgotPassword />
    }
    else if (route[1] == 'passwordreset') {
      console.log('Props: ', this.props)
      return <PasswordReset resetToken={ this.props.params.resetToken }/>
    }
    else if (userHash == null || userHash == '') {
      return (
        <div className="main-div">
          <Login />
        </div>
      )
    }
    else {
      // Grab user info if not present
      if (this.props.globals.loggedIn === false || this.props.globals.loggedInUser.organizationId == 0 || this.props.globals.loggedInUser.id == 0) {
        this.props.users.getUserFromHash(userHash, this.props.globals)
      }

      return (
        <div className="container body" style={{ height: 'inherit', display: 'table' }}>
        <Menu />
          <div className="main_container" style={{ height: 'calc(100% - 26px)' }}>
            <TopBar />
            { this.props.children }
            <div style={{ clear: 'both' }}></div>
            <Footer />
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/Main.js